import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import './ContactInfo.css';

const ContactInfo = () => {
  return (
    <div className="contact-info-container">
      <div className="contact-info">
        <h2 className="info-title">Contact Information</h2>
        <div className="info-details">
          <div className="info-item">
            <MapPin size={24} className="info-icon" />
            <div>
              <h3 className="info-subtitle">Office Address</h3>
              <p>Royal Heights Main Boulevard</p>
              <p>Royal Orchard Multan</p>
            </div>
          </div>
          
          <div className="info-item">
            <Phone size={24} className="info-icon" />
            <div>
              <h3 className="info-subtitle">Phone Numbers</h3>
              <p>Main: 0328-6506281</p>
              <p>Support: 0328-6506282</p>
            </div>
          </div>
          
          <div className="info-item">
            <Mail size={24} className="info-icon" />
            <div>
              <h3 className="info-subtitle">Email Address</h3>
              <p>gladiouscontrction@gmail.com</p>
            </div>
          </div>
          
          <div className="info-hours">
            <h3 className="info-subtitle">Business Hours</h3>
            <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
            <p>Saturday: 9:00 AM - 2:00 PM</p>
            <p>Sunday: Closed</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;